<template>
    <div class="footer-bottom">
      <CRow class="justify-content-center mb-2">
        <CCol style="display: flex; align-items: center; justify-content: center">
          <CCol sm="12" lg="12">
            <CCol
              sm="12"
              lg="12"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                left: 0;
                right: 0;
                position: fixed;
                bottom: 0px;
              "
            >
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoHome()">
                  <div v-if="homeclick===true">
                    <img src="../assets/img/icon/home-2.svg" class="btn-active"/>
                    <br />
                    <label class="text-blue"> Home</label>
                  </div>
                  <div v-if="homeclickgrey===true">
                    <img src="../assets/img/icon/homegrey.svg" />
                    <br />
                    <label class="text-non-active"> Home</label>
                  </div>
                </CCol>
              </CCol>
  
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoClass()">
                  <div v-if="classclick===true">
                  <img src="../assets/img/icon/book-blue.svg" />
                  <br />
                  <label class="text-blue"> Class</label>
                  </div>
                  <div  v-if="classclickgrey===true">
                  <img src="../assets/img/icon/iconBook.svg" />
                  <br />
                  <label class="text-non-active"> Class</label>
                  </div>
                </CCol>
              </CCol>
  
              <!-- <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoNotification()">
                  <div v-if="noticlick===true">
                  <img src="../assets/img/icon/iconBell.png" />
                  <br />
                  <label class="text-blue"> Notification</label>
                  </div>
                  <div  v-if="noticlickgrey===true">
                  <img src="../assets/img/icon/iconBell.png" />
                  <br />
                  <label class="text-non-active"> Notification</label>
                  </div>
                </CCol>
              </CCol> -->
  
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoTutor()">
                  <div v-if="tutorclick===true">
                  <img src="../assets/img/icon/teacher-blue.svg" />
                  <br />
                  <label class="text-blue"> Tutor</label>
                  </div>
                  <div  v-if="tutorclickgrey===true">
                  <img src="../assets/img/icon/iconTeacher.svg" />
                  <br />
                  <label class="text-non-active"> Tutor</label>
                  </div>
                </CCol>
              </CCol>
  
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoProfile()">
                  <div v-if="profileclick===true">
                  <img src="../assets/img/icon/profile-blue.svg" />
                  <br />
                  <label class="text-blue"> Profile</label>
                </div>
                <div v-if="profileclickgrey===true">
                  <img src="../assets/img/icon/profile-circle.svg" />
                  <br />
                  <label class="text-non-active"> Profile</label>
                </div>
                </CCol>
              </CCol>
            </CCol>
          </CCol>
        </CCol>
      </CRow>
    </div>
  </template>
  
              
  <script>
  import Vue from "vue";
  
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  
  Vue.use(require("vue-moment"));
  import moment from "moment";
  
  export default {
    components: {
      MainlayoutBottom,
    },
    data: function () {
      return {
        user: {},
        studentProfileAuthorize: "",
        schedule: [],
        hooperSettings: {
          itemsToShow: 2,
          centerMode: true,
          breakpoints: {
            800: {
              centerMode: false,
            },
            1000: {
              pagination: "fraction",
            },
          },
        },
        childs: [],
        parent: [],
        homeclick: false,
        classclick:false,
        profileclick: false,
        tutorclick: false,
        noticlick: false,
  
        homeclickgrey: true,
        classclickgrey: true,
        tutorclickgrey: true,
        profileclickgrey: true,
        noticlickgrey: true,
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },
    methods: {
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              this.GetAuthorizeProfile(this.user.id);
            }
          });
      },
      GoHome() {
        this.homeclick = true;
        this.homeclickgrey = false;
        this.$router.push("/ExistingUser");
        
      },
      GoProfile() {
        if (this.user.userType == "parent") {
          this.profileclick = true;
          this.profileclickgrey = false;
          this.$router.push("/ParentProfile/Profile");
          
        } else {
          this.profileclick = true;
          this.profileclickgrey = false;
          this.$router.push("/Tutor/TutorProfile");
          
        }
      },
      GoClass() {
        this.classclick = true;
        this.classclickgrey = false;
        this.$router.push("/Class/ClassMain");
      
      },
      GoTutor() {
        this.tutorclick = true;
        this.tutorclickgrey = false;
        this.$router.push("/FindTutor/FindTutorMainpage");
      },
    //   GoNotification() {
    //     this.noticlick = true;
    //     this.noticlickgrey = false;
    //     this.$router.push("/Notification");
    //   },
    },
  };
  </script>
  